import { type Auth0ContextInterface, useAuth0 } from "@auth0/auth0-react";
import { Button } from "@chakra-ui/react/button";
import { EmptyState } from "@chakra-ui/react/empty-state";
import React from "react";
import { LuTriangleAlert } from "react-icons/lu";
import { endSession } from "util/endSession";

// Module scope keeps the handler out of the component body (Rule #9); the
// factory is called during render to bind the agent's `logout`.
const createLogoutHandler = (logout: Auth0ContextInterface["logout"]) => () => {
  endSession(logout);
};

/**
 * Shown in place of the account list when the agent belongs to no merchants.
 *
 * The selector is opened with `required`, which removes the close trigger and
 * disables both escape-on-key and close-on-outside-click. With an empty list
 * that left a dialog carrying no control of any kind — the only exits were
 * editing the URL or clearing site data. Logging out is the one action that
 * can still resolve the state from inside the app.
 */
const NoAccounts = () => {
  const { logout } = useAuth0();

  return (
    <EmptyState.Root size="md">
      <EmptyState.Content>
        <EmptyState.Indicator>
          <LuTriangleAlert />
        </EmptyState.Indicator>
        <EmptyState.Title>No accounts available</EmptyState.Title>
        <EmptyState.Description>
          This login is not a member of any account. Contact support to restore
          access.
        </EmptyState.Description>
        <Button variant="solid" onClick={createLogoutHandler(logout)}>
          Log out
        </Button>
      </EmptyState.Content>
    </EmptyState.Root>
  );
};

export default NoAccounts;
